/**
 * This filters a list of students by grade_level and selected attributes
 * The enableGrade parameter is used to disable grade search.  This is here
 * so that when unassigned students is selected students are filtered by grade
 * but when a classroom is selected all students are shown for the source student
 * list.
 */
angular.module('rightPaneModule')
.filter('BulkMoveCopyStudentFilter', [function() {
    var attrs = ['first_name', 'grade_level', 'last_name', 'student_number', 'username'];
    function isMatch(item, grade, search, enableGrade) {
        if (enableGrade && grade && item.grade_level && grade !== item.grade_level) {
            return false;
        }

        if (search) {
            for (var n = 0; n < attrs.length; n++) {
                // check for null to avoid NPE on toLowerCase
                if (item[attrs[n]] !== null && item[attrs[n]].toLowerCase().indexOf(search) >= 0) {
                    return true;
                }
            }
            return false;
        } else {
            return true;
        }

    }
    return function(items, grade, search, enableGrade) {
        var out = [];
        search = search ? search.toLowerCase() : null;
        if (angular.isArray(items)) {
            items.forEach(function(item) {
                // set each item pre-search completion to disabled so select all can't function on them
                item.hidden = true;
                if (isMatch(item, grade, search, enableGrade)) {
                    out.push(item);
                    // set disabled false for items found in search so select all can work on them
                    item.hidden = false;
                }
            });
        } else {
            out = items;
        }
        return out;
    };
}]);
